export default {
  home: {
    title: 'Home',
    aiBannerTxt: {
      title: 'Bring AI Education to Life',
      subtitle: 'AI+ Education Digital Empowerment, Integrating Innovative Concepts',
      description: 'Focus on laser customization products and technical services, helping institutions & enterprises integrate "AI+ Education"'
    },
    description: 'Welcome to our Vue.js marketing site',
    banner: {
      slide1: {
        title: 'STEAM Kits | AI Kits | Laser Cutting Kits',
        description:
          'We provide innovative STEAM education solutions and kits for families, educators, and distributors, designed for children aged 3–16.',
      },
      slide2: {
        title: 'Professional kits designed to empower children’s creativity',
        description:
          'Courses, equipment, and software integrated for easy project-based learning',
      },
      slide3: {
        title: 'Future-oriented technology education',
        description:
          'Hands-on practice and interdisciplinary integration to build problem-solving and collaboration skills',
      },
    },
    factory: {
      banner: {
        alt: 'Smart Factory Banner',
        title: 'Smart Factory Solutions',
        description:
          'Production line setup | Industrial sensing | PLC control & data acquisition',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: 'Teaching Resources',
      resources: [
        {
          title: 'Project-based teaching materials',
          desc: 'Course PPTs and handouts, classroom activity designs, and assessment suggestions.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'Scenario examples and assets',
          desc: 'Examples and code snippets for conveyor control, station detection, and device linkage.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: 'Post-class extension tasks',
          desc: 'Extension tasks and cross-disciplinary application ideas that foster inquiry and creation.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: 'Product Introduction',
        desc: 'The Smart Factory solution centers on production line setup and programming control, covering industrial sensing, station recognition, PLC/microcontroller control, and data acquisition, with an emphasis on hands-on practice and systematic training.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: 'Accompanying Courses',
        desc: 'Project-based courses designed around production line setup, industrial sensing, PLC control, and data acquisition, emphasizing practical operation and systematic training.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'Conveyor module',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: 'Photoelectric sensor',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'PLC control unit',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'Robotic arm module',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'Barcode recognition module',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: 'Temperature & humidity sensor',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'Motor driver module',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: 'Workstation detection module',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: 'Emergency stop module',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'Data acquisition gateway',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Zetok STEAM Education Solutions',
      learnMore: 'Learn more >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Zetok Kits',
          description:
            'Hands-on practice and project-based learning cultivate innovative thinking and practical skills.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Good Laser cutting & engraving machines',
          description:
            'Laser machines bring a new hands-on learning experience to STEAM education',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: 'Teaching Scenarios',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'STEM education solutions',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'Makerspace solutions',
        },
      ],
    },
    aiBanner: {
      alt: 'AI Banner',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Zetok Kits',
      title: 'Artificial Intelligence Kits',
      description:
        'AI kits typically include rich interactive and practical projects that spark students’ interest and curiosity in technology.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'Kits carousel',
      title: 'Boost innovative thinking',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Zetok Kits & Good Laser cutting machines',
      tabs: {
        kits: 'Kits',
        courses: 'Courses',
        laser: 'Laser equipment',
        software: 'Software',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'Laser cutting starter kit',
            description: '(Includes wood consumables)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'Wonderful Science Box',
            description: '(Includes wood + micro-circuit kit pack)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'AI programming kit',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: 'Science exploration system – Early childhood',
            description: '(6 courses)',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'STEAM makers system – Youth',
            description: '(3 courses)',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'Laser cutting courses',
            description: '(3 courses)',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'AI course system',
            description: '(4 courses)',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530 ',
            description: '55W desktop CO2 laser cutter & engraver',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description: 'Professional desktop laser cutter & engraver',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530 ',
            description: 'Smart desktop blue-light laser cutter & engraver',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: 'High-precision laser marking machine',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Zetok Learning Platform',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Zetok Cloud Platform',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },
  switch_lang: 'English',
  nav: {
    products: 'Products',
    smartFarm: 'Smart Farm',
    smartHome: 'Smart Home',
    smartTraffic: 'Smart Traffic',
    smartFactory: 'Smart Factory',
    laserSteam: 'Laser Cutting STEAM Kits',
    dreamScience: 'Dream Science Kits',
    course: 'Courses',
    device: 'Devices',
    education: 'Education Solutions',
    stem: 'STEM Education Solutions',
    maker: 'Makerspace Solutions',
    software: 'Software',
    service: 'Service & Support',
    afterSale: 'Tutorial Downloads',
    about: 'About Us',
    aboutUs: 'About Us',
    dealer: 'Become our distributor',
    cooperation: 'Product use & education cooperation',
    news: 'News',
    coursesSeries: 'Four Course Series',
    viewMore: 'View more',
    store: "Store"
  },
  globalContactForm: {
    title: 'Contact Us',
    subtitle:
      'If you have any questions or needs, please contact us at any time. We are happy to help.',
    fields: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      message: 'Message',
    },
    placeholders: {
      name: 'Please enter your name',
      email: 'Please enter your email address',
      phone: 'Please enter your contact number',
      company: 'Please enter your company name',
      message: 'Please describe your needs or questions',
    },
    validation: {
      name: 'Please enter your name',
      email: 'Please enter your email address',
      emailFormat: 'Invalid email format',
      phone: 'Please enter your contact number',
      message: 'Please enter your message',
    },
    submit: 'Submit',
    submitting: 'Submitting…',
    visual: {
      title: 'Professional Services',
      description:
        'We focus on technology creativity education for children aged 3–16, run innovation spaces, and develop related products and courses.',
    },
    contact: {
      phone: 'Service Hotline',
      email: 'Email Address',
    },
  },
  thankYou: {
    metaTitle: 'Thank you for your submission',
    title: 'Thanks for your submission!',
    description:
      'We have received your information and will contact you as soon as possible.',
    seoDescription: 'Submission successful; our team will contact you shortly.',
    backHome: 'Back to Home',
    browseProducts: 'Continue browsing products',
    contactSupport: 'Contact after-sales support',
    nextStepsTitle: 'What happens next',
    nextSteps: [
      'We will review your request within 1–2 business days.',
      'If we need more information, we will reach out proactively.',
      'You can continue browsing or contact us by phone/email.',
    ],
    contactTitle: 'Need immediate assistance?',
    contactPhoneLabel: 'Service hotline:',
    contactEmailLabel: 'Email:',
  },
  about: {
    banner: {
      alt: 'About Us Banner',
      title:
        'Zetok focuses on innovative education, offering high-quality kits and courses',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: 'Our Mission',
      desc: 'Our mission is to empower education, spark innovation, and cultivate future leaders and innovators through advanced AI technologies. We believe that providing high-quality educational tools and solutions helps students and educators reach their potential.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: 'Our Vision',
      desc: 'Technology empowers education, enabling every student to access quality STEM resources, unlock potential, and become future innovators and leaders.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: 'Our Products',
      tabs: ['Kits', 'Courses', 'Laser equipment'],
      items: [
        {
          title: 'Kits',
          desc: 'We provide a diverse range of STEM kits, including AI, robotics, programming, and science experiments. These kits are well-designed, easy to use, and suitable for different age groups.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'Courses',
          desc: 'Our courses are carefully designed by education experts to integrate with the kits and provide a comprehensive learning experience. Content ranges from foundational concepts to advanced applications, suitable for learners at different levels.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'Laser equipment',
          desc: 'Our laser cutting and engraving equipment is designed for educational environments—safe, precise, and easy to operate. These devices give students the opportunity to turn creativity into tangible works.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'Join us as a Zetok distributor',
        title: 'Join us as a Zetok distributor',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title: 'Open new opportunities in education and share innovation!',
        desc: 'Zetok invites you to co-develop new paths in STEM education with AI kits and laser equipment that inspire student creativity. Join us to win the future together!',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: 'Our Mission',
        items: [
          {
            title: 'Leading products',
            desc: 'Access top-quality STEAM education tools on the market.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: 'Attractive returns',
            desc: 'Enjoy competitive discounts and sales incentives.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: 'Marketing support',
            desc: 'Get marketing materials and sales training to quickly enter the market.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'Brand partnership',
            desc: 'Work with Zetok to leverage brand influence and market resources.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: 'Cooperation Banner',
        title: 'Product Cooperation',
        cta: 'Contact now',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: 'Unleash the potential of future scientists and engineers',
        desc: 'Join our STEM education promotion program for special offers and product trials designed for educators. We provide innovative STEM tools for the classroom and exclusive discounts to help you cultivate the next generation of innovators and problem solvers.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: 'Act now and open a new chapter in STEM education!',
        items: [
          {
            title: 'Free product trials',
            desc: 'Try our tools before you buy.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: 'Exclusive discounts',
            desc: 'Affordable STEM solutions for your classroom or school.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: 'Educational resources',
            desc: 'Rich teaching resources and lesson plans to support your teaching.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'Contact Us',
        desc: 'If you have any questions or needs, feel free to contact us; we are here to help.',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'News Center Banner',
        title: 'News Center',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'News Center',
      tabs: [
        { key: 'company', label: 'Company Updates' },
        { key: 'industry', label: 'Industry News' },
        { key: 'expo', label: 'Expo Events' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zetok releases a new classroom AI kit',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: 'Pilot STEM projects in cooperation with local schools',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title: 'Software updates improve classroom management experience',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: 'Host teacher training workshops',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: 'Distribution network expands to more regions',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: 'New course series focuses on real project practice',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: 'Annual review highlights innovation achievements',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title: 'Community initiatives bring STEM to youth',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title: 'Global trend: Project-based learning in STEM',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: 'AI in education: emerging best practices',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title: 'New curriculum standards emphasize hands-on skills',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title: 'Educational hardware better meets classroom needs',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title: 'STEAM programs continue to advance across districts',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title: 'Sustainability projects enter STEM classrooms',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title: 'Makerspaces shape innovative learning approaches',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zetok appears at edtech expo',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title: 'Student project results showcased at regional expos',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title: 'Interactive makerspace demos attract attention',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: 'Visual programming workshop for teachers',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: 'New equipment showcased to education partners',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },
  finance: {
    contact: {
      success: 'Submission successful, we will contact you soon',
      error: 'Submission failed, please try again later',
      networkError: 'Network error, please check your connection and try again',
    },
  },
  footer: {
    subscribePlaceholder: 'Your phone number and email address',
    subscribe: 'Subscribe',
    subscribeSuccess: 'Subscription successful',
    contact: {
      sales: 'Sales Hotline: +86 18379276683',
      service: 'Service Hotline: +86 400 968 0598',
      email: 'Email: sam@zz-steam.com',
      address:
        'Address: Building A, Huashengda Plaza, Bagua 4th Road, Futian, Shenzhen',
    },
    icp: 'Privacy Policy · User Agreement © Zhongze Education (Shenzhen) Co., Ltd. Guangdong ICP No. 2024289240-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'STEM Education Solutions Banner',
        title: 'Creative leadership in STEM education',
        description:
          'For K12, we focus on creative STEM education—ignite curiosity, build logical thinking, and spark passion for programming.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: 'AI and Programming Education',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: 'Easy to learn and use',
            description:
              'Block-based programming, beginners get started in seconds and easily build AI projects.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: 'Powerful features',
            description:
              'Smart hardware, voice interaction—endless creativity.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: 'Highly extensible',
            description:
              'Connect components and hardware, unlock imagination, and create without limits.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: 'Rich courses',
            description:
              'Accompanying courses from basics to hands-on practice help students build a solid knowledge system.',
          },
        ],
      },
      scenes: {
        title: 'Explore our featured courses',
        items: [
          {
            tab: 'School Education',
            title: 'AI School Education',
            desc: 'Use AI kits to build intelligent voice assistants; hands-on practice sparks interest and cultivates logic and programming skills.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'Competition Training',
            title: 'Competition Training',
            desc: 'Smart kits support robotics competitions and tech innovation; students design intelligent works, enhancing collaboration and creativity.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: 'Home Learning',
            title: 'Home Learning',
            desc: 'Parents and children learn AI projects together—develop hands-on skills, strengthen relationships, and improve tech literacy.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title: 'AI + Education: Opening a new era of smart learning',
        desc: 'Leverage AI to personalize learning paths and enable precise teaching, so every student can navigate the ocean of knowledge without barriers.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'STEM Series Kits',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'Makerspace Solutions Banner',
        title: 'Explore our makerspace',
        description:
          'In the makerspace, education and innovative technologies combine to provide students with a platform for hands-on practice and exploration.',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: 'Comprehensive makerspace skills',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: 'Technology tools application',
            desc: 'Block-based programming, easy to start—beginners can quickly build AI projects.',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: 'Openness and flexibility',
            desc: 'A makerspace encourages free exploration—a dedicated playground to unleash creativity.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'Hands-on practice',
            desc: 'Build, experiment, and explore—start a practical learning journey.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: 'Collaborative learning',
            desc: 'Encourage teamwork to cultivate collaboration and communication skills.',
          },
        ],
      },
      scenes: {
        title: 'Makerspace application scenarios',
        items: [
          {
            tab: 'School crafts courses',
            title: 'School crafts courses',
            desc: 'A strong supplement to courses such as handicrafts and art design.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: 'Innovation practice clubs',
            title: 'Innovation practice clubs',
            desc: 'Provide a practical platform for school innovation practice clubs.',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: 'Educational laboratories',
            title: 'Educational laboratories',
            desc: 'Suitable for schools, universities, or labs; refresh the learning environment with professional laser engravers for students.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: 'Tools to realize creativity',
        desc: 'Leverage precise cutting of laser cutters and intelligent interaction of programmable robots to transform abstract ideas into tangible works.',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'Makerspace Series Kits',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: 'Software Page Banner',
      title: 'Zetok Software Center',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'Software Downloads',
      items: [
        {
          key: 'lightmaker-app',
          icon: require('@/assets/software/s1.png'),
          name: 'Light Maker App',
          buttonText: 'Download Mobile App',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: require('@/assets/software/s2.png'),
          name: 'Good-Laser Light Maker',
          buttonText: 'Download Desktop Client',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: require('@/assets/software/s3.png'),
          name: 'Zetok Learning Platform App',
          buttonText: 'Download Mobile App',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'Zetok Learning Platform',
          buttonText: 'Download Desktop Client',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: 'Light Maker — dedicated software for laser devices',
          desc: 'Integrates graphic design and device control in one, saving time and providing an all-in-one design and laser control solution.',
        },
        items: [
          {
            image: require('@/assets/software/s1.png'),
            title: 'Powerful, easy-to-use design system',
            desc: 'A robust creation suite supporting high-quality designs in JPG, DWG, DXF, AI, DST, PNG, BMP, TIF, and SVG formats.',
          },
          {
            image: require('@/assets/software/s2.png'),
            title: 'Professional-grade',
            desc: 'Professional drawing features for all production needs—handles complex designs and simple cutting with ease.',
          },
          {
            image: require('@/assets/software/s3.png'),
            title: 'Easy to operate',
            desc: 'User-friendly interface with support for multiple laser devices—intuitive UI and efficient cutting/engraving processing.',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'Light Maker — dedicated software for laser devices',
          desc: 'Integrates graphic design and device control in one, saving time and providing an all-in-one design and laser control solution.',
        },
        items: [
          {
            image: require('@/assets/software/s1.png'),
            title: 'Powerful, easy-to-use design system',
            desc: 'A robust creation suite supporting high-quality designs in JPG, DWG, DXF, AI, DST, PNG, BMP, TIF, and SVG formats.',
          },
          {
            image: require('@/assets/software/s2.png'),
            title: 'Professional-grade',
            desc: 'Professional drawing features for all production needs—handles complex designs and simple cutting with ease.',
          },
          {
            image: require('@/assets/software/s3.png'),
            title: 'Easy to operate',
            desc: 'User-friendly interface with support for multiple laser devices—intuitive UI and efficient cutting/engraving processing.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'Zetok Cloud Platform',
          desc: 'An innovative education management tool offering a one-stop solution for teachers, students, and schools—covering homework distribution, device monitoring, repairs, and parameter configuration.',
        },
        items: [
          {
            image: require('@/assets/software/c1.png'),
            title: 'Convenient operation',
            desc: 'One-click creation: built-in asset library and parameter presets simplify workflows. Device monitoring: real-time status monitoring ensures smooth teaching activities.',
          },
          {
            image: require('@/assets/software/c2.png'),
            title: 'Unified management',
            desc: 'Device parallelization: supports paralleling other makerspace devices with one-click management to improve efficiency.',
          },
          {
            image: require('@/assets/software/c3.png'),
            title: 'Real-time monitoring',
            desc: 'Device status: understand the running status in real time and report faults promptly. Maintenance: guided by runtime and usage frequency, the system reminds regular maintenance to extend device life and improve cutting quality.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'Zetok Learning Platform',
          desc: 'An innovative online learning tool providing a comprehensive educational software solution for students and teachers—accessible on both mobile devices and computers.',
        },
        items: [
          {
            image: require('@/assets/software/pc1.png'),
            title: 'Smart and convenient, beginner-friendly',
            desc: 'Rich asset libraries and preset parameters support one-click creation for fast onboarding. Detailed mobile guides help beginners master operations. Cloud services enable real-time monitoring of classroom devices to ensure safe and efficient teaching.',
          },
          {
            image: require('@/assets/software/pc2.png'),
            title: 'AI creation',
            desc: 'One-click creation and AI image generation simplify design workflows and improve efficiency. Enter simple prompts or upload reference images, and AI generates high-quality, cut-ready assets automatically.',
          },
          {
            image: require('@/assets/software/pc3.png'),
            title: 'A new efficient learning experience',
            desc: 'The Zetok Learning Platform integrates course study, graphic design, and laser processing with a simple, user-friendly workflow. A card-based homepage clearly separates modules for learning, design, and processing, enabling seamless transitions and significantly boosting efficiency.',
          },
        ],
      },
    },
  },
  product: {
    farm: {
      banner: {
        alt: 'Smart Farm Banner',
        title: 'Smart Farm Learning Kit',
        btnText: 'Buy Now',
        description:
          'Project-based teaching | Programming + Hardware + AI | Suitable for K–12',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'Project Course Content',
        resourceTitle: 'Teaching Resources',
        equipmentsTitle: 'Equipment Configuration',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: 'Diverse course content',
          desc: '12 lessons from basic to advanced: progress from temperature detection to smart irrigation and temperature control.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: 'Interdisciplinary knowledge integration',
          desc: 'Each project involves programming, electronics, and mechanical structures, helping students apply knowledge comprehensively and develop cross-disciplinary thinking.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: 'Life-oriented themes',
          desc: 'Smart Farm themes are close to daily life and easily spark student interest and engagement.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: 'Complete teaching PPTs and handouts',
          desc: 'Teaching PPTs and handouts for 16 lessons, closely aligned with projects, provide rich materials and reduce lesson preparation workload.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'Assembly videos for project-based courses',
          desc: 'Videos visually demonstrate project assembly, helping students understand and master steps to improve learning efficiency.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: 'Supplementary teaching materials',
          desc: 'Handouts and other aids provide detailed guidance, making review and self-study easier.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'RGB LED strip',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 clock module',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 temperature & humidity sensor',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Human motion sensor (PIR)',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED lighting module',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Fan module',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Slot-type optocoupler switch',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Button module',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Control board',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Expansion board',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    home: {
      banner: {
        alt: 'Smart Home Learning Kit Banner',
        title: 'Smart Home Learning Kit',
        btnText: 'Buy Now',
        description:
          'Programming & AI enlightenment | Project-based teaching | Ideal for K–12 tech classes',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'Advantages of the Smart Home Starter Kit',
      resources: [
        {
          title: 'Rich resources',
          desc: 'Provides complete teaching resources to facilitate teaching and learning.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: 'Interdisciplinary integration',
          desc: 'Each project involves programming, electronics, and mechanical structures, helping students apply knowledge comprehensively and develop cross-disciplinary thinking.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: 'Post-class extension tasks',
          desc: 'Extension tasks and cross-disciplinary application suggestions to encourage inquiry and creation.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: 'Accompanying Courses',
        desc: 'Includes 12 premium project courses covering smart home topics such as electronic doorbells, dimmable porch lights, sensor-enabled garages, password access control, gas alerts, anti-theft alarms, colorful lights, music ambience lights, daylight detection, room temperature detection, and temperature-controlled fans.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: 'Multiple application scenarios',
      scenes: [
        {
          title: 'Classroom teaching',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: 'Independent creative development',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: 'Family parent–child interaction',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'Event demonstrations',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: 'Equipment Configuration',
      equipments: [
        {
          title: 'RGB LED strip',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 clock module',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 temperature & humidity sensor',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Human motion sensor (PIR)',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED lighting module',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Fan module',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Slot-type optocoupler switch',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Button module',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Control board',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Expansion board',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    factory: {
      banner: {
        alt: 'Smart Factory Banner',
        title: 'Smart Factory Learning Kit',
        btnText: 'Buy Now',
        description: ` · Full coverage of sensing/control/drive <br>
 · Simulate real production lines<br>
 · Cultivate “future engineers”`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: 'Product Features',
      resources: [
        {
          title: 'Industry 4.0 core experience',
          desc: 'On a simulated production line, students practice sensing, control, drive, and data management.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'Project-based learning',
          desc: 'Includes programming tutorials and 12 PPT-backed lessons for easy learning.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'Simulated real scenarios',
          desc: 'Smart robotic arms, automatic sorting systems, and smart warehouses simulate logistics and inventory management to start a STEM practice journey.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: 'Product Introduction',
        desc: 'The Smart Factory learning set is a project-based teaching kit that combines programming, electronic hardware, mechanical structures, laser cutting, and AI literacy. Suitable for primary and secondary school teaching, it adopts the theme “Smart Manufacturing · Creating and Sharing the Future”, using simulated production environments to cultivate scientific inquiry, engineering design, programming control, and collaborative innovation.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: 'Accompanying Courses',
        desc: '12 premium courses covering topics such as Smart Factory basics, understanding production processes, sensor applications, fundamentals of mechanical drive, building conveyor systems, automatic sorting, workstation collaborative control, assembly robotic arms, and intelligent sorting—emphasizing hands-on practice and systematic training.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: 'Equipment Configuration',
      equipments: [
        {
          title: 'RGB LED strip',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 clock module',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 temperature & humidity sensor',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Human motion sensor (PIR)',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED lighting module',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Fan module',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Slot-type optocoupler switch',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Button module',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Control board',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Expansion board',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    kits: {
      laserSteam: {
        banner: {
          alt: 'Laser Cutting STEAM Kits Banner',
          title: 'Laser Cutting STEAM Kits',
          btnText: 'Buy Now',
          description:
            'An all-in-one manufacturing education solution that cultivates innovation and teamwork',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        resourcesTitle: 'Advantages of Laser Cutting STEAM Kits',
        resources: [
          {
            title: 'Multiple intelligences theory',
            desc: 'Based on the theory of multiple intelligences, courses develop creativity, critical thinking, problem-solving, and collaboration skills.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'Project-based learning',
            desc: 'Through project-based learning, students learn by doing, increasing efficiency and interest.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'STEAM education',
            desc: 'Course content integrates science, technology, engineering, art, and mathematics to build interdisciplinary thinking.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: 'Detailed accompanying teaching',
          tabs: [
            { key: 'cutter', label: 'Laser cutter' },
            { key: 'lesson', label: 'Accompanying courses' },
            { key: 'material', label: 'Teaching materials' },
            { key: 'software', label: 'Software' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        aiBanner: {
          title: 'AI Education, A Smart Start',
          desc: 'Integrate STEAM education with AI to build a comprehensive learning experience.',
        },
        equipmentsTitle: 'Equipment Configuration',
      },
      // 逐梦科学套件（Dream Science Kit）
      dreamScience: {
        banner: {
          alt: 'Dream Science Kit Banner',
          title: 'Wonderful Science Box (Dream Science Kit)',
          description:
            'Scientific concepts | Scientific thinking | Inquiry practice | Attitude & responsibility',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'Kit Contents',
        resources: [
          {
            title: 'Science experiment materials',
            desc: 'Used to complete various science experiments and projects.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: 'Teaching resources',
            desc: 'Includes teaching PPTs and handouts supporting a semester of activities—closely aligned with projects and key knowledge points.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: 'Assembly videos and handouts',
            desc: 'Supplementary materials to help students better understand and master operation steps.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: 'Teaching Objectives',
        objectives: [
          {
            title: 'Scientific inquiry skills',
            desc: 'Ask questions, plan, and collect/analyze data',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'Engineering practice skills',
            desc: 'Build and test hands-on, iteratively improve solutions',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: 'Interdisciplinary integration',
            desc: 'Combine mathematics, physics, and art to complete projects',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: 'Target audience',
          description:
            'Primary and secondary school students: suitable for different ages, helping improve scientific literacy and practical skills. Teachers: provides teaching resources and guidance to better conduct classroom activities.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: 'Intro section image',
        },
      },
    },
    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: 'View All Kits Banner',
        title: 'Kits Series',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'Project-centered learning where students complete tasks to build problem-solving skills.',
      moreText: 'Learn More',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'Smart Farm Learning Kit',
          desc: 'Project-centered approach that sparks creativity and hands-on skills, building practical problem-solving.',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'Smart Home Learning Kit',
          desc: 'Combines programming, electronics, mechanical structures, laser cutting, and AI literacy for a comprehensive learning experience.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'Smart Traffic Learning Kit',
          desc: 'A project-based teaching kit integrating programming, electronics, mechanical structures, laser cutting, and AI literacy.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'Smart Factory Learning Kit',
          desc: 'Covers AI fundamentals and practical cases, guiding students step by step to build a systematic knowledge framework.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Laser Cutting STEAM Kits',
        //   desc: 'Guided by multiple intelligences theory, STEAM education, and project-based learning.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Dream Science Kit',
        //   desc: 'Meets needs across learning stages, inspiring scientific interest and exploration.',
        //   link: '/products/farm',
        // },
      ],
    },
    traffic: {
      banner: {
        alt: 'Smart Traffic Banner',
        title: 'Smart Traffic Learning Kit',
        btnText: 'Buy Now',
        description: `12 project-based courses 
  <br>· Block-based/Python dual programming  <br>
 · Real scenario simulation<br>
 · Teach right out of the box`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: 'Product Features',
      resources: [
        {
          title: 'Scientific inquiry and innovation',
          desc: 'Students build smart traffic systems using electronic modules and mechanical structures.',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: 'Highly educational',
          desc: 'Construct smart street lights, traffic lights, crosswalks, and parking lots to understand smart traffic concepts.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: 'Rich resources',
          desc: 'Complete resources including PPTs and handouts for 12 lessons, assembly videos, and supplementary materials.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: 'Product Introduction',
        desc: 'The Smart Traffic K–12 kit centers on “Smart Travel” and “Traffic Safety”, combining electronic control and sensors to guide students to design and build smart traffic systems, simulate real scenarios, and cultivate scientific literacy and innovation.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: 'Accompanying Courses',
        desc: 'Project-based courses covering traffic sensing/control basics, signal linkage, path planning, and more—adapted to different stages and class durations.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: 'Equipment Configuration',
      equipments: [
        {
          title: 'RGB LED strip',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'DS1307 clock module',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'DHT11 temperature & humidity sensor',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Human motion sensor (PIR)',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'LED lighting module',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Fan module',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Slot-type optocoupler switch',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Button module',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Control board',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Expansion board',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    banner: {
      alt: 'Products Home Banner',
      title: 'Zetok Products & Solutions',
      description:
        'Integrated kits, courses, devices, and software that support project-based learning',
      image: 'https://picsum.photos/id/1069/1600/900',
    },
    courses: {
      banner: {
        alt: 'Courses Section Banner',
        title: 'Four Course Systems',
        description:
          'Course content covers science, technology, engineering, art, and mathematics (STEAM), fostering interdisciplinary integration and application.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: 'Explore Our Signature Courses',
        nav: ['Age 3–6', 'Age 6–12', 'Age 8–13', 'Age 9–15'],
        entries: [
          {
            title: 'Science Exploration — Early Childhood (6 courses)',
            desc: 'Explore everyday phenomena with scientific teaching aids to understand rules and principles.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'STEAM Makers — Youth (3 courses)',
            desc: 'Express creativity using equipment and hands-on practice to turn ideas into works.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'Laser Cutting Curriculum (3 courses)',
            desc: 'Cut various structural parts, assemble 3D structures, and beautify them. Programming: learn logical principles of conditional judgment.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: 'Artificial Intelligence Curriculum (4 courses)',
            desc: 'Use equipment tools to design and build the appearance of works, then program to make them smart and simple, solving everyday problems.',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'Course Advantages',
        details: [
          {
            title: 'Strong hands-on practice',
            description: 'Hands-on practice turns theory into skills',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: 'Cultivate innovative thinking',
            description: 'Design hands-on and solve problems creatively',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'Project-driven learning',
            description:
              'Learn through projects and master knowledge in practice',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: 'Explore the technology frontier',
            description:
              'Keep pace with the frontier and learn smart kit applications',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: 'Systematic teaching',
            description: 'Content progresses from basics to practice',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: 'Fun and challenging',
            description:
              'Fun sparks interest; challenges unlock potential; grow through exploration.',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: 'AI Series Courses',
        items: [
          {
            name: 'Smart Farm',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'Smart Home',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'Smart Traffic',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'Smart Factory',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'AI Courses Banner',
        text: 'Project-driven learning with interdisciplinary integration; cultivates hands-on, collaboration, and problem-solving. Balances safety and individuality, showcases outcomes to boost achievement and support growth.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },
    laser: {
      banner: {
        alt: 'Laser Products',
        title: 'Good Laser Products',
        description:
          'Safe, easy-to-use laser cutting/engraving equipment and solutions for educational scenarios',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: 'Our Advantages',
      extraNote: {
        light640_640:
          'Outstanding cutting and engraving results\nMultiple models and laser power options for different applications\nLaser type: DC CO2  Laser power: 60W–130W',
      },
      center: {
        title: 'Product Center',
        laser_accessories: 'Laser Accessories',
        air_purifier_name: 'Air Purifier',
        description:
          'Laser equipment solutions tailored to schools at different teaching levels. Zetok offers four official laser equipment solutions; schools can choose according to actual teaching needs.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'High-quality, high-precision laser',
                bgColor: '#4285F4',
                description:
                  'Thickened high-quality CO2 laser tube (wavelength 10,640 nm) delivering 55 W CO2 laser power. Cuts acrylic up to 20 mm, up to 600 mm/s working speed, and 0.025 mm repeat positioning accuracy—quickly and precisely producing delicate creative works.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Integrated triple exhaust filtration box',
                bgColor: '#FFBC0C',
                description:
                  'Multi-stage smoke filtration (mesh filter, activated carbon, UV ozone) in an integrated design—cleaner and more eco-friendly, with convenient and compact placement. No need for a separate filter box or extra space.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Top-priority safety protection',
                bgColor: '#34A853',
                description:
                  'Passed highest safety tests by SGS labs and FDA-certified as Class I. Distinct safety and status lights make machine operation states clear at a glance.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Easy-to-use, powerful laser cutting system',
                bgColor: '#0F9D58',
                description:
                  'Set process parameters by material (cut, deep engrave, shallow engrave, scan). Rich design assets improve efficiency. Camera supports fixed-point capture to assist design and turn creativity into reality.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Working area',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610(1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Efficient auto-focus + red dot positioning',
                  bgColor: '#FFBC0C',
                  description:
                    'Auto-focus quickly and accurately sets focus before cutting/engraving. With the red-dot positioning beam you can view the working position in real time. The Good Laser 640 series saves time and delivers better cutting/engraving results.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Open rear door design',
                  bgColor: '#34A853',
                  description:
                    'The open rear door design allows placing materials of unlimited length. 600mm x ∞ sheet support makes work more convenient with fewer limitations.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Outstanding cutting and engraving results',
                  bgColor: '#4285F4',
                  description:
                    'Equipped with a spacious cutting platform, processing wood and acrylic reaches enterprise-level precision and efficiency. Capable of mass-producing fine laser craftworks to boost productivity and scaling.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Premium laser tube & precision components',
                  bgColor: '#FFBC0C',
                  description:
                    'A diversified product line lets you choose laser types and processing speeds to meet different production needs—offering rich possibilities for wood, glass, acrylic, and more.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Rigorous beam quality testing, guaranteed',
                  bgColor: '#34A853',
                  description:
                    'After strict testing, precise optical path control, and more than five cutting/engraving trials, we select top CO2 laser tubes with stable, consistent output. Excellent power stability and fine spot enable uniform engraving and intricate details.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Comprehensive & advanced safety features',
                  bgColor: '#4285F4',
                  description: `1. Emergency stop
<br>2. Warning light 
<br>3. Waterproof switch 
<br>4. Ground wire 
<br>5. Built-in heat detector alarm auto-activates on abnormal activity
<br>6. Flip-cover protection
<br>7. Durable tempered-glass protective window`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Durable, excellent quality',
                  bgColor: '#FFBC0C',
                  description: `1. Ideal for single pieces or mass production.
<br>2. Wide working area range from 600 x 400 mm to 1600 x 1000 mm.
<br>3. Unparalleled engraving speed.
<br>4. Designed by industry experts.
<br>5. Perfect for personalization, education, and industrial applications.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Optimize production through smart monitoring',
                  bgColor: '#34A853',
                  description:
                    'Developed to protect sensitive components (axes, laser head, optics, lenses) from dust and dirt—ensuring years of fault-free operation even under heavy use.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Efficient auto-focus + red dot positioning',
                  bgColor: '#4285F4',
                  description:
                    'Auto-focus quickly and accurately sets focus before cutting/engraving. With the red-dot positioning beam you can view the working position in real time. Light 1610 saves time and delivers better cutting/engraving results.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Outstanding cutting and engraving results',
                  bgColor: '#FFBC0C',
                  description:
                    'Equipped with a spacious cutting platform, processing wood and acrylic reaches enterprise-level precision and efficiency. Capable of mass-producing fine laser craftworks to boost productivity and scaling.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Durable, excellent quality',
                  bgColor: '#34A853',
                  description: `1. Ideal for single pieces or mass production. 
<br>2. Wide working area range from 600 x 400 mm to 1600 x 1000 mm.
<br>3. Unparalleled engraving speed. 
<br>4. Designed by industry experts. 
<br>5. Perfect for personalization, education, and industrial applications.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Portable blue-light engraver',
                bgColor: '#4285F4',
                description:
                  'Stylish, modern, compact design fits in any home, school, or studio. Metal body with an acrylic lid. Small footprint suits any desktop while delivering powerful 20W performance for improved cutting.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Fully enclosed processing for safety',
                bgColor: '#FFBC0C',
                description:
                  'Fully enclosed design auto-pauses when the lid opens mid-task. In emergencies, a single switch shuts down the machine. Suitable for homes and schools.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title:
                  'Multi-material processing, supports hundreds of materials',
                bgColor: '#34A853',
                description:
                  'Customize unique shapes/styles and add accessories to engrave more forms—like cups and cylindrical objects—ideal for small business needs.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Versatile application scenarios',
                bgColor: '#4285F4',
                description:
                  'Suited for many industries: jewelry engraving, personalized items, parts identification, and more—meeting custom needs from jewelry and perfume bottles to small industrial nameplates.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Innovative applications in education',
                bgColor: '#FFBC0C',
                description:
                  'Brings industrial-grade precision to education, serving as an “all-around assistant” for innovation education—building student capability from basic marking to complex project development.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Compact and modern',
                bgColor: '#34A853',
                description:
                  'Compact, modern design with small footprint, low noise, and large viewing window—built for high durability. Sleek appearance meets safety standards for schools and public retail environments.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Marking completed in seconds',
                bgColor: '#0F9D58',
                description:
                  'Even with the smallest fonts, Mark achieves precise marking within seconds. Paired with LightMaker laser software’s streamlined workflow and efficiency, it significantly boosts productivity.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'Accessories',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
                  · Applicable venues: suitable for places with smoke, odors, dust, or toxic/harmful gases.
<br>· Application fields: electronics, toy manufacturing, precision hardware, medical, and more.
<br>· Design: configurable single or dual workstation.
<br>· Filtration: equipped with multi-layer filtering devices.
<br>· Airflow: stepless adjustment based on exhaust volume.
<br>· Purification: effective adsorption and filtration with up to 99.97% purification.
<br>· Air discharge: purified clean air can be released indoors.
`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· Device type: auxiliary equipment for laser cutting/engraving machines.
                     <br>· Use: enables rotational motion of workpieces.
<br>· Compatible objects: cylindrical, tubular, and similar shapes.
<br>· Extended function: expands from flat material processing to cylinder processing.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `


· High-efficiency forming machine offering precise forming.
<br>· CNC system control for easy operation.
<br>· Multiple forming dies available.
<br>· Quick-clamping system improves efficiency.
<br>· Comprehensive safety protection.
<br>· Suitable for forming various materials.
`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
  },
  support: {
    afterSales: {
      banner: {
        alt: 'Tutorial Downloads Banner',
        title: 'Tutorial Downloads',
        image: require('@/assets/after/banner.png'),
      },
      downloadText: 'Download Tutorials',
      items: [
        {
          id: 'mk-1',
          name: 'Smart Farm',
          image: 'https://picsum.photos/seed/as-farm1/588/391',
          link: '#',
        },
        {
          id: 'mk-2',
          name: 'Smart Home',
          image: 'https://picsum.photos/seed/as-home1/588/391',
          link: '#',
        },
        {
          id: 'mk-3',
          name: 'Smart Traffic',
          image: 'https://picsum.photos/seed/as-traffic1/588/391',
          link: '#',
        },
        {
          id: 'mk-4',
          name: 'Smart Factory',
          image: 'https://picsum.photos/seed/as-factory1/588/391',
          link: '#',
        },
        {
          id: 'mk-5',
          name: 'Maker Space',
          image: 'https://picsum.photos/seed/as-makerspace1/588/391',
          link: '#',
        },
        {
          id: 'mk-6',
          name: 'Robotics Courses',
          image: 'https://picsum.photos/seed/as-robot1/588/391',
          link: '#',
        },
        {
          id: 'mk-7',
          name: 'AI Tutorials',
          image: 'https://picsum.photos/seed/as-ai1/588/391',
          link: '#',
        },
        {
          id: 'mk-8',
          name: 'IoT Tutorials',
          image: 'https://picsum.photos/seed/as-iot1/588/391',
          link: '#',
        },
      ],
    },
  },
};
